const GreeksSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">



            {/* Investment Strategy */}
            <div className="col-lg-12 mt-30">
              <div className="about__content">
                <div
                  className="about__content-inner"
                  data-aos="fade-right"
                  data-aos-duration="500"
                >
                  {/* <h3 className="section-title mb-3">Greeks</h3> */}
                  <p className="mb-4">

                    One of the most elementary strategies of an option trader, it involves buy and selling option of different strike price. Trading with GATS option spread trader makes it a walk in a park. This multidimensional algorithm with various permutations and parameters

                    astonishes the users with superior execution.
                  </p>

<p>Implied volatility spreads, User defined IV v/s Current Implied volatility spread, Absolute (Premium) Price spread, Vega Difference spread</p>

                </div>
              </div>
            </div>


                  <div className="key-points">
                    <ul>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                         Hedging with, underlying, futures, options, synthetic or multi legged
                      </li>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        User defined Net delta hedging parameters
                      </li>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        Auto balancing quantity ratio based on Delta, Vega or Gamma.
                      </li>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        Calendar spreads (inter prompt contracts)
                      </li>
                      <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        Strategy fill trackers
                      </li>
                       <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        2-Leg IOC orders (Sniper Orders)
                      </li>
                       <li>
                        <i className="fas fa-check-circle"></i>{" "}
                        Leap & Jump - Optimize the spread automatically with change in market spread
                      </li>
                    </ul>
                  </div>
              



          </div>
        </div>
      </div>
    </section>
  );
};

export default GreeksSection;
